<template>
  <!-- Lista de valores: diagnostico -->
  <div class="modal fade" id="ModalDiagnosticoLOV" tabindex="-1" aria-labelledby="ModalLabelLOV" aria-hidden="true">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header bg-primary">
          <h5 class="modal-title" id="ModalLabelLOV">
            <i class="fa fa-user-plus"></i> {{ tituloLOV }}
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          </button>
        </div>
        <br>
        <div class="mb-3">
		
<div class="container mb-3">
  <div class="row justify-content-center g-2 align-items-center">
    <div class="col-md-8">
      <div class="d-flex">
        <input
          type="text"
          class="form-control me-2 flex-grow-1"
          id="nombreBusquedaLOV"
          name="nombreBusquedaLOV"
          v-model="nombreBusquedaLOV"
          placeholder="Ingrese código CIE-10 o descripción ..."
          style="text-transform: uppercase;"
          required
        >
        <button
          type="submit"
          class="btn btn-primary d-flex align-items-center"
          @click.prevent="getDataPaginaLOV(1)"
          title="Buscar registros"
        >
          <span class="material-symbols-outlined me-1" style="font-size: 24px;">search</span>
          Buscar
        </button>
      </div>
    </div>
  </div>
</div>

        </div>
        <table class="table table-striped" id="sampleTableLOV">
          <thead>
            <tr>
              <th scope="col">Código - Descripción</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="diagnostico in datosPaginadosLOV" :key="diagnostico.idDiagnostico">
                  <td><a href="#" v-on:click="seleccionarRegistro(diagnostico.idDiagnostico, diagnostico.codigo, diagnostico.nombre)"
                         data-bs-target="#ModalDiagnosticoLOV" data-bs-toggle="modal">{{ diagnostico.nombreExt }}</a></td>
            </tr>
          </tbody>
        </table>
        <nav aria-label="Page navigation example">
          <div class="row" style="text-align: center;">
            <div class="col"></div>
            <div class="col">
              <ul class="pagination">
                <li class="page-item" v-on:click="getPreviousPageLOV()"><a class="page-link" href="#">Anterior</a></li>
                <li class="page-item"><a class="page-link" href="#">{{ paginaActualLOV }}</a></li>
                <li class="page-item" v-on:click="getNextPageLOV()"><a class="page-link" href="#">Siguiente</a></li>
              </ul>
            </div>
            <div class="col"></div>
          </div>
        </nav>
      </div>
    </div>
  </div>
<!-- Lista de valores: Diagnostico -->
</template>
<script>
import api from "@/services/api";
export default {
  data() {
    return {
      // Lista de valores: Diagnostico
      nombreBusquedaLOV: '',
      tituloLOV: 'Lista de Diagnósticos',
      DiagnosticoLOV: [],
      elementosPorPaginaLOV: 10,
      datosPaginadosLOV: [],
      paginaActualLOV: 1
      // Lista de valores: Diagnostico
    }
  },
mounted() {
  const modal = document.getElementById("ModalDiagnosticoLOV");
  if (modal) {
    modal.addEventListener("hidden.bs.modal", () => {
      this.nombreBusquedaLOV = "";
      this.DiagnosticoLOV = [];
      this.datosPaginadosLOV = [];
      this.paginaActualLOV = 1;
    });
  }
},
  methods: {
    // Lista de valores: Diagnostico
    totalPaginasLOV() {
      return Math.ceil(this.DiagnosticoLOV.length / this.elementosPorPaginaLOV)
    },
    getDataPaginaLOV(noPagina) {
      if (this.nombreBusquedaLOV != null && this.nombreBusquedaLOV !== ""){
        api.get('/vwdiagnosticos/nombreext/'+this.nombreBusquedaLOV).then(response=>{ 
          this.DiagnosticoLOV = response.data;
          this.paginaActualLOV = noPagina;
          this.datosPaginadosLOV = [];
          let ini = (noPagina * this.elementosPorPaginaLOV) - this.elementosPorPaginaLOV;
          let fin = (noPagina * this.elementosPorPaginaLOV);
          this.datosPaginadosLOV = this.DiagnosticoLOV.slice(ini, fin);
          this.datosPaginadosLOV = this.DiagnosticoLOV.slice(ini, fin);
        });
      }
      else{
        alert("ERROR: Ingrese un valor de consulta Diagnostico");
      }
    },
    getPreviousPageLOV() {
      if (this.paginaActualLOV > 1) {
        this.paginaActualLOV--;
      }
      this.getDataPaginaLOV(this.paginaActualLOV);
    },
    getNextPageLOV() {
      if (this.paginaActualLOV < this.totalPaginasLOV()) {
        this.paginaActualLOV++;
      }
      this.getDataPaginaLOV(this.paginaActualLOV);
    },
    seleccionarRegistro(p_idDiagnostico, p_codigo, p_nombre) {
      this.$emit("DatosDiagnostico", { idDiagnostico: p_idDiagnostico, codigo: p_codigo,  nombre: p_nombre });
    }
  }
}
</script>
<style scoped>
::placeholder {
  color: #C0C0C0; /* gris Bootstrap */
  opacity: 1;     /* para que no sea transparente */
}
</style>